import { TableCell } from "@/components/ui/table";
import { useBasketMonitor, normalizeBasketSymbol, BasketTakeProfit } from "@trader-dashboard/shared";

type PairBasketTakeProfitCellsProps = {
  symbol: string;
};

const sideLabel = (target: BasketTakeProfit, showSide: boolean): string =>
  showSide ? (target.side === "buy" ? "B " : "S ") : "";

const formatPriceDistance = (distance: number | null): string => {
  if (distance === null) return "-";
  if (distance <= 0) return "Reached";
  return distance.toFixed(5);
};

/**
 * Basket take profit (weighted average entry ± target pips) and how far price
 * still has to go, one line per open side. ≈ marks a partially synced basket.
 */
export const PairBasketTakeProfitCells = ({ symbol }: PairBasketTakeProfitCellsProps): React.ReactNode => {
  const { basketTakeProfits } = useBasketMonitor();
  const targets = basketTakeProfits.get(normalizeBasketSymbol(symbol)) ?? [];
  const showSide = targets.length > 1;

  return (
    <>
      <TableCell className="text-right">
        <div className="font-medium text-lg text-center">
          {targets.length === 0
            ? "-"
            : targets.map((target) => (
                <div key={target.side}>
                  {sideLabel(target, showSide)}
                  {target.partialSync ? "≈" : ""}
                  {target.takeProfitPrice.toFixed(5)}
                </div>
              ))}
        </div>
      </TableCell>
      <TableCell className="text-right">
        <div className="font-medium text-lg text-center text-muted-foreground">
          {targets.length === 0
            ? "-"
            : targets.map((target) => (
                <div key={target.side}>
                  {sideLabel(target, showSide)}
                  {formatPriceDistance(target.priceToTakeProfit)}
                </div>
              ))}
        </div>
      </TableCell>
    </>
  );
};
